import type { PersonAction } from "../types/personActions.js";
import type { UserId } from "../types/user.js";

/**
 * Whether somebody may open a guest's Details on a person's case, from
 * what they hold over the record (`personActionsOf`): whoever may involve a
 * guest there, and whoever added this guest for as long as they still read the
 * record. Deciding who is involved (`assign`) is not enough, so an admin may
 * end a guest without reading what the guest has done.
 *
 * See `docs/decisions/2026-10-31-whoever-added-a-guest-may-see-what-they-have-done-while-they-reach-the-person.md`.
 */
export const mayReadGuestDetails = ({
  conveyed,
  actorUserId,
  startedByUserId,
}: {
  conveyed: readonly PersonAction[];
  actorUserId: UserId;
  startedByUserId: UserId;
}): boolean =>
  conveyed.includes("involve_guest") ||
  (actorUserId === startedByUserId && conveyed.includes("read"));
